import React from 'react';
import { BooleanSettings } from 'modules/settingsContainer/common/BooleanSettings';
import { OnValueChange } from 'types/global';

type ShowNameIncIncisionSettingsProps = OnValueChange<boolean>;

export const ShowNameIncIncisionSettings = ({ value, onChange }: ShowNameIncIncisionSettingsProps) => (
  <BooleanSettings titleText="Показать название разрезов" value={value} onChange={onChange} />
);
